define((require) => {
    "use strict";

    const Class  = require("shared/util/Class");
    const Window = require("shared/services/Window");

    /**
     * Exposes a SalesforceCommerce Site Genesis Strategy Class.
     *
     * @class SalesforceCommerceQuickViewSiteGenesisStrategy
     */
    return Class.extend({

        _strategy: null,

        /**
         * Sets the chosen QuickView strategy.
         * @param {SalesforceCommerceQuickViewSiteGenesisStrategy} strategy - The chosen strategy.
         */
        setStrategy(strategy) {
            this._strategy = strategy;
        },

        /**
         * Returns a *client site jQuery* element wrapping the root of the opened SalesforceCommerce QuickView if
         * currently available (probably a very old jQuery version).
         *
         * @return {jQuery} The SalesforceCommerce QuickView root element, if currently available; can be falsey.
         */
        _quickViewRoot() {
            const $ = Window.sandbox("$");
            if ($) {
                const root = $("#QuickViewDialog");
                if (root.length && typeof root.dialog === "function") {
                    return root;
                }
            }
            return null;
        },

        /**
         * Opens the specific QuickView given the chosen strategy.
         * @param {String} productID The SalesforceCommerce OCAPI Product Id.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         */
        open(productID, experienceName, currentScene) {
            this._strategy.open(productID, experienceName, currentScene);
            return this._quickViewRoot();
        },

        /**
         * Format the QuickView parameters.
         * @param {String} productID The SalesforceCommerce OCAPI Product Id.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         * @returns {string}
         */
        formatParameters(productID, experienceName, currentScene) {
            experienceName = encodeURIComponent(experienceName);
            return `?format=ajax&zmagssrc=creator&experienceName=${experienceName}&experienceScene=${currentScene}&pid=${productID}`;
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisStrategy.js